import { BasicInfoProps, CaseInfo, RealDealData } from '../../data';
import { s } from './Summary.styles';
import ImgSlider from './ImgSlider';
import NavigationTab from './NavigationTab';
import Tags from '../../../../func/Tags';
import { formatToEokMan } from '../../../../func/Function';
import { useEffect, useState } from 'react';
import InterestSerivce from '../../../../service/Interest';
import AddInterestItemModal from '../../../components/modal/AddInterestItem';
interface ImgItem {
  imgNo: string;
  src: string;
  description?: string;
}

interface Props {
  caseInfo: CaseInfo;
  imgList: ImgItem[];
  basicInfo: BasicInfoProps | undefined;
  realPriceData: RealDealData | undefined;
}

const Summary = ({ caseInfo, imgList, basicInfo, realPriceData }: Props) => {
  const [isLikeItem, setIsLikeItem] = useState(false);
  const [showLikeModal, setShowLikeModal] = useState(false);
  const [mode, setMode] = useState<string>('add');
  const [selectedItem, setSelectedItem] = useState({
    iidx: 0,
    group: '',
    group_idx: 0,
    level: 0,
    memo: '',
  });
  const [activeItem, setActiveItem] = useState<number | null>(null);

  const checkIsLikeItem = async (iidx: number) => {
    try {
      const res = await InterestSerivce.check(iidx);
      setIsLikeItem(res.data.is_like);
    } catch (error) {
      console.error('checkIsLikeItem 함수에서 에러 발생:', error);
    }
  };

  useEffect(() => {
    if (caseInfo.iidx) {
      checkIsLikeItem(caseInfo.iidx);
    }
  }, [isLikeItem]);

  const handleCopyAddress = () => {
    navigator.clipboard
      .writeText(caseInfo?.iaddr ? caseInfo.iaddr : '')
      .then(() => {
        alert('주소가 복사되었습니다!');
      })
      .catch((err) => {
        console.error('주소 복사에 실패했습니다:', err);
        alert('주소 복사에 실패했습니다.');
      });
  };

  const handleTopAction = (action: string) => {
    if (action === 'share') {
      const currentUrl = window.location.href;
      navigator.clipboard
        .writeText(currentUrl)
        .then(() => {
          alert('URL이 복사되었습니다!');
        })
        .catch(() => {
          alert('URL 복사에 실패했습니다.');
        });
    }
  };

  const disLike = async (iidx: number) => {
    try {
      const res = await InterestSerivce.dislike(iidx);
      alert('관심물건에서 삭제되었습니다.');
      setIsLikeItem(false);
    } catch (error) {
      console.error('dislike 함수에서 에러 발생:', error);
    }
  };

  const handleDisLikeItem = (iidx: number) => {
    if (window.confirm('관심물건에서 삭제하시겠습니까?')) {
      disLike(iidx);
    }
  };

  return (
    <s.Container id="요약정보">
      {/* <s.CaseNumberBox>
        <span>
          {caseInfo.caseno}
          {caseInfo?.type == 'p'
            ? '-' + caseInfo?.itemno
            : caseInfo?.itemno.replace(/[^0-9]/g, '')
              ? ' (' + caseInfo?.itemno.replace(/[^0-9]/g, '') + ')'
              : ' (1)'}
        </span>
        <s.CourtName>[{caseInfo.branchName}]</s.CourtName>
      </s.CaseNumberBox> */}
      {imgList.length > 0 && <ImgSlider imgList={imgList} />}
      <NavigationTab />
      <s.SummaryBox>
        <s.Block flexDir="column">
          <s.ItemTypeChip
            style={{
              backgroundColor: caseInfo.type === 'a' ? '#FFDBD6' : '#DEEDFF',
              color: caseInfo.type === 'a' ? '#D84836' : '#0C64CE',
            }}
          >
            {caseInfo.type === 'a' ? '경매' : '공매'}
          </s.ItemTypeChip>
          <s.AddressBox>
            <s.JiBunAddressBox>
              <s.JibunAddress>{caseInfo.iaddr}</s.JibunAddress>
              <s.CopyButton onClick={handleCopyAddress}>
                <img src="/assets/images/icon/copy-blue.svg" alt="" />
                <span>복사</span>
              </s.CopyButton>
            </s.JiBunAddressBox>
            {caseInfo.roadnamelocation && (
              <s.RoadAddress>({caseInfo.roadnamelocation})</s.RoadAddress>
            )}
          </s.AddressBox>
          <s.SaleDate>
            <span>{caseInfo.type === 'a' ? '매각기일' : '입찰기간'}</span>
            <span style={{ color: '#222' }}>{caseInfo.saleDate}</span>
          </s.SaleDate>
          <Tags data={caseInfo}></Tags>
        </s.Block>
        {caseInfo.type === 'a' && caseInfo.date && (
          <s.Block flexDir="row" paddingB={24} borderB>
            <s.BidInfoItem>
              <span>개시결정</span>
              <s.BidInfoContent>
                {caseInfo.date.start_date.split(': ')[1]}
              </s.BidInfoContent>
            </s.BidInfoItem>
            <s.Divider></s.Divider>
            <s.BidInfoItem>
              <span>배당요구종기일</span>
              <s.BidInfoContent>
                {caseInfo.date.div_date.split(': ')[1]}
              </s.BidInfoContent>
            </s.BidInfoItem>
            <s.Divider></s.Divider>
            {caseInfo.bid === '매각' || caseInfo.bid === '낙찰' ? (
              <s.BidInfoItem>
                <span>매각결정기일</span>
                <s.BidInfoContent style={{ color: 'f45551' }}>
                  {caseInfo.saleDate}
                </s.BidInfoContent>
              </s.BidInfoItem>
            ) : (
              <s.BidInfoItem>
                <span>경매시작일</span>
                {caseInfo.date.remaining_days !== null ? (
                  <s.BidInfoContent>
                    D
                    {caseInfo.date.remaining_days > 0
                      ? `-${caseInfo.date.remaining_days}`
                      : `+${Math.abs(caseInfo.date.remaining_days)}`}
                  </s.BidInfoContent>
                ) : (
                  <s.BidInfoContent>-</s.BidInfoContent>
                )}
              </s.BidInfoItem>
            )}
          </s.Block>
        )}
        <s.Block flexDir="row">
          <s.PriceBox>
            <div>감정가</div>
            <s.Price>{formatToEokMan(basicInfo?.appraisalPrice)}</s.Price>
          </s.PriceBox>
          <s.PriceBox>
            <div>최저가</div>
            <s.Price>{formatToEokMan(basicInfo?.minimumPrice)}</s.Price>
          </s.PriceBox>
          <s.PriceBox>
            <div>실거래 매매가</div>
            {realPriceData &&
            realPriceData?.sale.length > 0 &&
            realPriceData?.sale_summary.length ? (
              <s.Price>
                {formatToEokMan(realPriceData?.sale_summary[0].dealprice)}
              </s.Price>
            ) : (
              <s.Price>실거래 없음</s.Price>
            )}
          </s.PriceBox>
          <s.PriceBox>
            <div>실거래 전세가</div>
            {realPriceData &&
            realPriceData.jeonse.length > 0 &&
            realPriceData.jeonse_summary.length > 0 ? (
              <s.Price>
                {formatToEokMan(realPriceData.jeonse_summary[0].dealprice)}
              </s.Price>
            ) : (
              <s.Price>실거래 없음</s.Price>
            )}
          </s.PriceBox>
        </s.Block>
      </s.SummaryBox>
      <s.InterestButtonBox>
        <s.InterestButton onClick={() => handleTopAction('share')}>
          <img src="/assets/images/icon/upload-gray.svg" alt="" />
          <span>공유</span>
        </s.InterestButton>
        <s.Divider> </s.Divider>
        <s.InterestButton
          onClick={(e) => {
            e.stopPropagation();

            if (!isLikeItem) {
              setShowLikeModal(true);
            } else {
              handleDisLikeItem(caseInfo.iidx);
            }
          }}
        >
          <img
            src={`/assets/images/icon/${isLikeItem ? 'filled-star' : 'lined-star'}.svg`}
            alt=""
          />
          <span>관심</span>
        </s.InterestButton>
      </s.InterestButtonBox>
      {showLikeModal && (
        <AddInterestItemModal
          setShowLikeModal={setShowLikeModal}
          selectedIdx={caseInfo.iidx}
          mode={mode}
          selectedItem={selectedItem}
          setActiveItem={setActiveItem}
          checkIsLikeItem={checkIsLikeItem}
        />
      )}
    </s.Container>
  );
};

export default Summary;
